import React from 'react'
import { FormCommonDisplayProps } from './FormCommon'
import { toDisplayFromCamelCase } from '../../../Utilities';

export function FormLabel(props: FormCommonDisplayProps<any>) {
  return <label className="col-form-label form-label" htmlFor={props.name}>
    {`${props.displayName ?? toDisplayFromCamelCase(props.name)}:`}
  </label>
}
